import React from 'react';

const ImageViewer = ({ idTicket, nomFichiers,statutTicket }) => {

  const handleClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!Array.isArray(nomFichiers) || nomFichiers.length === 0) {
   return (
      <div className="d-flex flex-column flex-wrap justify-content-center text-center">
        <p>Aucun fichier à afficher.</p>
        {statutTicket === 2 && (
          <p className="text-muted">Veuillez réouvrir le ticket pour ajouter des fichiers.</p>
        )}
      </div>
    );
  }

  return (
     <div className="d-flex flex-wrap justify-content-center gap-3 p-3">
      {nomFichiers.map((nomFichier, index) => {
        const encodedFileName = encodeURIComponent(nomFichier);
        const imageUrl = `https://cloud.niralakka.fr/${window.entreprise}/ticket/${idTicket}/${encodedFileName}`;

        return (
          
          <img
            key={index}
            src={imageUrl}
            alt={nomFichier}
            onClick={() => handleClick(imageUrl)}
            style={{
              width: '100%',
              maxWidth: '300px',
              height: 'auto',
              borderRadius: '8px',
              objectFit: 'cover',
              margin: '10px',
            }}
            onError={() => {
              // console.log(`Impossible de lire l'image : ${nomFichier}`);
            }}
          />
        );
      })}
    </div>
  );
};

export default ImageViewer;
